export default __webpack_public_path__ + "static/media/Long_DarkBlue.448b7cfc.png";